<template>
  <div class="award_content" v-if="data.style" :style="'position: relative;background-color:'+data.style.backgroundColor">
    <div class="award_top" :style="'position: relative;background-image:url('+oss+data.style.backgroundImage+');'">
      <div class="title text-ac s_font_b fz-35 p-t-20" :style="'color:'+data.style.titleColor">恭喜您中奖啦!</div>
      <div class="award_main">
        <div class="award_main_items">
          <div class="award_main_item">
            <img src="@/assets/images/scan/product.png" alt="" class="width-60 height-60">
            <p class="s_font_b fz-12 m-l-20 m-r-15">贵州飞天茅<br />台53度...</p>
            <div class="btn" :style="'background-color:'+data.style.textColor">立即领取</div>
          </div>
          <div class="award_main_item s_flex_ali">
            <div class=" m-r-10" :style="'color:'+data.style.textColor">
              <div class="s_flex_ali m-b-5"><span class="fz-12">￥</span>
                <div class="fz-20 s_font_b">10</div>
              </div>
              <div class="s_font_b">优惠券</div>
            </div>
            <div>
              <div class="fz-14 s_font_b m-b-18  p-l-15">获得10元优惠券</div>
              <div class="fz-12  " :style="'color:'+data.style.textColor">
                <div class="s_scale_9 p-l-10">已到帐,可到云店购买抵扣现金</div>
              </div>
            </div>
          </div>
          <div class="award_main_item">
            <div class=" m-r-10" :style="'color:'+data.style.textColor">
              <div class="text-ac m-b-5">
                <div class="fz-20 s_font_b">10</div>
              </div>
              <div class="s_font_b">会员积分</div>
            </div>
            <div>
              <div class="fz-14 s_font_b m-b-18  p-l-5">获得10元会员积分</div>
              <div class="fz-12  s_scale_9" :style="'color:'+data.style.textColor">已到帐,请前往会员中心查看</div>
            </div>
          </div>
          <div class="award_main_item">
            <div class=" m-r-10" :style="'color:'+data.style.textColor">
              <div class="s_flex_ali m-b-5 "><span class="fz-12">￥</span>
                <div class="fz-20 s_font_b">10</div>
              </div>
              <div class="s_font_b">微信红包</div>
            </div>
            <div>
              <div class="fz-14 s_font_b m-b-18 p-l-5">获得10元微信红包</div>
              <div class="fz-12  s_scale_9" :style="'color:'+data.style.textColor">已到帐,请到微信钱包查看</div>
            </div>
          </div>
        </div>
        <div class="award_main_footer">
          <span>愉快收下</span>
          <img src="@/assets/images/scan/red_btn.png" alt="">
        </div>
      </div>
      <div class="award_btn" v-if="data.params&&data.params.btnKey.length">
        <div v-if="data.params.btnKey.indexOf('cloud')!=-1"><img src="@/assets/images/scan/store_icon.png" alt=""> 云店商城</div>
        <div v-if="data.params.btnKey.indexOf('center')!=-1"><img src="@/assets/images/scan/center_icon.png" alt="">会员中心</div>
      </div>
      <div class="ranking ">
        <div class="rankTabs s_flex_center s_cfff fz-16 m-b-20" v-if="data.params&&data.params.rankingKey.length">
          <div class="tabsItem flex_1 text-ac" v-if="data.params.rankingKey.indexOf('red')!=-1">红包排行榜</div>
          <div class="tabsItem flex_1 text-ac" v-if="data.params.rankingKey.indexOf('point')!=-1">积分排行榜</div>
        </div>
        <div class="rankList s_bf s_bor10 p-t-10 p-l-20 p-b-10">
          <div class="item s_flex_center s_c999 fz-12 m-b-15">
            <div class="flex_1 ">排行</div>
            <div class="flex_3">昵称</div>
            <div class="flex_2 ">红包总收入</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_one.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿01</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_two.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿02</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1"><img src="@/assets/images/scan/scan_ranking_tree.png" alt="" class="width-20"></div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿03</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">04</div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿04</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">05</div>
            <div class="flex_3 s_c1212 fz-14"> <img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">
              幸运儿05</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
          <div class="item s_flex_center  m-b-15">
            <div class="flex_1 s_c999 fz-12">06</div>
            <div class="flex_3 s_c1212 fz-14"><img src="@/assets/images/user.png" alt="" class="width-24 m-r-5">幸运儿06</div>
            <div class="flex_2 s_c1212 fz-16">888.00元</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import config from "@/config";
export default {
  props: { data: Object },
  name: "award",
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.award_content {
  width: 100%;
  height: 100%;
  overflow: scroll;
  .award_top {
    height: 667px;
    overflow: visible;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    .award_main {
      height: 354px;
      width: 308px;
      background-image: url("../../../../../../../assets/images/scan/red_bg.png");
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      top: 183px;
      left: 50%;
      transform: translateX(-50%);
      .award_main_items {
        position: absolute;
        bottom: 115px;
        left: 50%;
        transform: translateX(-50%);
        .award_main_item {
          width: 254px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url("../../../../../../../assets/images/scan/red_coupon.png");
          background-size: contain;
          background-repeat: no-repeat;
          margin-bottom: 1px;
          .btn {
            width: 60px;
            height: 24px;
            background: #e81425;
            border-radius: 12px;
            font-size: 12px;
            text-align: center;
            line-height: 24px;
            color: #fee8b0;
          }
        }
      }
      .award_main_footer {
        width: 306px;
        height: 125px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        background-image: url("../../../../../../../assets/images/scan/red_footer.png");
        background-size: contain;
        background-repeat: no-repeat;
        text-align: center;
        span {
          position: absolute;
          transform: translateX(-50%);
          z-index: 1;
          font-weight: 500;
          color: #ff3600;
          top: 62.5px;
          font-size: 14px;
        }
        img {
          width: 140px;
          height: 56px;
          left: 50%;
          position: absolute;
          transform: translateX(-50%);
          bottom: 21px;
        }
      }
    }
    .award_btn {
      width: 320px;
      height: 48px;
      background: #e2152d;
      border-radius: 48px;
      position: absolute;
      top: 560px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      z-index: 1;
         >div:nth-child(2){
           &::before {
        content: "";
        width: 32px;
        height: 32px;
        background-image: url("../../../../../../../assets/images/scan/line.png");
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      }
      > div {
        flex: 1;
        text-align: center;
        line-height: 48px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #fee6ac;
        img {
          width: 21px;
          height: 21px;
          margin-right: 10px;
        }
      }
    }
    .ranking {
      position: absolute;
      top: 540px;
      width: 300px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>